export const typeOptions = [
  {
    title: "文字型",
    type: "elevatorText",
    iconName: "nav-text-icon",
    iconActiveName: "nav-text-active-icon"
  },
  {
    title: "图文型",
    type: "elevatorImgText",
    iconName: "nav-imgText-icon",
    iconActiveName: "nav-imgText-active-icon"
  },
  {
    title: "图片型",
    type: "elevatorImg",
    iconName: "nav-img-icon",
    iconActiveName: "nav-img-active-icon"
  }
];
export const positionOptions = [
  {
    label: "当前位置插入",
    value: "nowPosition"
  },
  {
    label: "顶部",
    value: "topPosition"
  },
  {
    label: "底部",
    value: "bottomPosition"
  }
];

export const wayOptions = [
  {
    label: "下拉展示",
    value: "pulldown"
  },
  {
    label: "横向滚动",
    value: "row"
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/ElevatorNavigation/options.js